import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  tone?: 'light' | 'dark';
};
export function Countdown({
  tone = 'light'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  const labelColor = tone === 'dark' ? 'text-brand-100' : 'text-brand-700';
  return <div className="mt-6 flex flex-col items-center" role="timer" aria-live="off" data-id="element-2" data-mp="3h1iezwy5tb3p">
      <p className={`flex items-center gap-2 text-xs sm:text-sm font-bold uppercase tracking-wide ${labelColor}`} data-id="element-3" data-mp="323ybyvktpq06">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-4" data-mp="3729pbgabuin5" />
        The special launch offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2 sm:gap-3" data-id="element-5" data-mp="10dejno4hx1u6">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-6" data-mp="15bocvt6ntsd5" data-mpi={i}>
            {i > 0 && <span className={`pt-3 font-serif text-3xl font-bold ${labelColor}`} aria-hidden="true" data-id="element-7" data-mp="y0wujld43wkh">
                :
              </span>}
            <div className="flex flex-col items-center" data-id="element-8" data-mp="t1k6ixai8jgb">
              <span className={`flex h-[68px] w-[68px] sm:h-20 sm:w-20 items-center justify-center rounded-xl font-serif text-4xl sm:text-5xl font-bold tabular-nums ${tone === 'dark' ? 'bg-white text-brand-800' : 'bg-brand-800 text-white'}`} data-id="element-9" data-mp="17rhouwlr6exl">
                {String(unit.value).padStart(2, '0')}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${labelColor}`} data-id="element-10" data-mp="o2qu786yeyhq">
                {unit.label}
              </span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}